/** @jsx jsx */
import { Fragment, h } from 'preact';
import { useState } from 'preact/hooks';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { StarFull } from '../../Icons/StarFull';

import { Prices } from '../../Prices/Prices';
import { fetchLocaleField } from '../../Helpers';

// CSS
import '../../Result/result.css';

export function ATCWithVariantSelectProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

	const context = getContext(['region']);
	const core = result?.mappings?.core;

	const hoverImage = result?.attributes?.ss_image_hover;
	const promptSelection = window.variantStrings.promptSelection;
  const currencySymbol = window.Resources.shopCurrencySymbol;
	const priceRange = result?.attributes?.ss_price_range ? result?.attributes?.ss_price_range : null;
	const onSale = result?.attributes?.ss_on_sale ? "on--sale" : "not-on--sale";
	const reviewScore = result?.attributes.reviews_product_score ? Number(result?.attributes.reviews_product_score) : null;
	const reviewTotal = result?.attributes.reviews_total_reviews;

	//Parse variants string returned from SS
  const variantsObject = Array.from(JSON.parse(result?.attributes?.variants));

	const badge = fetchLocaleField(result, 'mfield_cql_badge', 'mfield_french_badge');

	//States
  //Variant id once selected
  const [selectedVariantId, setSelectedVariantId] = useState(promptSelection);
  const [variantPrice, setVariantPrice] = useState(0);

	// Handle fr product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result', typeof hoverImage != 'undefined' && 'ss__result__hover', `ss__result--${layout}`, className)}>
			<div
				data-href={productUrl}
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className={`ss__result-link ${onSale}`}
				aria-label={core.name}
				onClick={(e) => {
					//Only click thru to the PDP if the user clicks something that's not the ATC or Variant selector
					const eventTarget = e.target;

					if(
						!eventTarget.classList.contains("cart-upsell-card__variant") &&
						!eventTarget.classList.contains("ss__results__form") &&
						!eventTarget.classList.contains("button")
					){
						window.location.href = e.target.closest("[data-href]")?.dataset?.href;
					}
				}}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						{badge && <div className="ss__badge ss__result__badge">{badge}</div>}
						<div {...styling} className={classnames('ss__image', 'ss__result__image')}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.4967637540453074"
								data-sizes="auto"
								data-image
								src={core.imageUrl}
							/>

							{typeof hoverImage != 'undefined' && (
								<img
									id={`ProductImage-${result.id}`}
									alt={core.name}
									class="product__img product__img--hover lazyload"
									data-aspectratio="1.4967637540453074"
									data-sizes="auto"
									data-image
									src={hoverImage}
								/>
							)}
						</div>
					</div>
					<div className="ss__result__details">
						<div className="ss__result__details__top_row body-large">
							<div className="ss__result__details__review">
								{reviewScore && reviewScore != null && (
									<>
										<StarFull />
										<span className="review-score">{reviewScore.toFixed(1)}</span>
										<span className="review-total">({reviewTotal})</span>
									</>
								)}
								{reviewScore == null && <div className="ss__results__no-reviews">{window.Resources.searchspring.productCards.noReviews}</div>}
							</div>

							<div className="ss__result__details__pricing body-medium">
								{context.region == 'us' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{context.region == 'ca' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{/* Only display UK prices if the market is equal to UK as well. */}
								{context.region == 'uk' && window.Resources.marketHandle == 'uk' && (
									<Prices priceRange={priceRange} core={core} subProps={parentSubProps} />
								)}
							</div>
						</div>

						<div className="ss__result__details__title body-medium">{core.name}</div>

						<form method="post" action="/cart/add" className="ss__results__form">
							<select
								className={`cart-upsell-card__variant ${variantsObject?.length <= 1 ? 'cart-upsell-card__variant--hidden' : ''}`}
								onChange={e => {

									//On variant select, update id state
									setSelectedVariantId(e.target.value);

									//Find variant selected and grab it's price too
									const index = e.target.selectedIndex;
									const optionElement = e.target.childNodes[index];
									const price = optionElement.dataset.variantPrice;

									//Update price state
									setVariantPrice(price);
								}}
								aria-label={window.Resources.searchspring.results.currentlyViewing}
							>
								{variantsObject?.length > 1 &&
                	<>
										{/* First variant always Select Size */}
										<option disabled="disabled" selected="selected">{promptSelection}</option>
									</>
								}

								{/* Then, loop through real variants */}
								{variantsObject.map((variant) => (
									<option
									value={variant.id} 
									disabled={variant?.inventory_quantity <= 0 ? "disabled" : false}
									data-variant-price={variant?.price}
									>
										{variant.title}
									</option>
								))}
							</select>

							{/* Hidden form inputs */}
							{/* Variant id storage, with state */}
							<input type="hidden" name="id" value={`${variantsObject?.length <= 1 ? variantsObject[0]?.id : selectedVariantId}`} />

							{/* Quantity always set to 1 */}
							<input className="hidden" min="1" type="number" id="quantity" name="quantity" value="1"/>

							{/*
              	If there are no variants (aka only 1 variant in Shopify)
              	then show a different button, not disabled
							*/}
							{variantsObject?.length == 1 &&
								<button
									className="button button--primary-black"
									type="submit"
								>

									{window.Resources.searchspring.productCards.addToCart}{"\u00a0"}

									{context.region == 'us' && variantPrice !== 0 && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}

									{context.region == 'ca' && variantPrice !== 0 && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}

									{context.region == 'uk' && variantPrice !== 0 && window.Resources.marketHandle == 'uk' && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}
								</button>
							}

							{/* If there are variants, show different ATC button, already disabled */}
							{variantsObject?.length > 1 &&
								<button
									className="button button--primary-black"
									type="submit"
									disabled={selectedVariantId == promptSelection ? "disabled" : false}
								>

									{window.Resources.searchspring.productCards.addToCart}{"\u00a0"}

									{context.region == 'us' && variantPrice !== 0 && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}

									{context.region == 'ca' && variantPrice !== 0 && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}

									{context.region == 'uk' && variantPrice !== 0 && window.Resources.marketHandle == 'uk' && (
										<>
											- {currencySymbol}{variantPrice}
										</>
									)}
								</button>
							}
						</form>
					</div>
				</div>
			</div>
		</article>
	);
}
